import { Box, BoxProps, styled } from '@mui/material';
import { WsTypoColors, WsTypography } from 'wisestep-base';

const StyledNoResponseBox = styled(Box)(({ theme }) => ({
  minHeight: 500,
  width: '100%',
  display: 'flex',
  rowGap: theme.spacing(1.5),
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

interface EmptyResponseCardProps extends BoxProps {
  src: string;
  text: string;
  subText: string;
  alt?: string;
}

const EmptyResponseCard = ({
  src,
  alt = 'No response',
  text,
  subText,
  ...boxProps
}: EmptyResponseCardProps) => (
  <StyledNoResponseBox {...boxProps}>
    <img src={src} alt={alt} />
    <WsTypography bold>{text}</WsTypography>
    <WsTypography color={WsTypoColors.SECONDARY}>{subText}</WsTypography>
  </StyledNoResponseBox>
);

export default EmptyResponseCard;
